import Axios from 'axios'

import { globals } from '../main'



Axios.defaults.baseURL = process.env.VUE_APP_QPAY_URL;
// Axios.defaults.baseURL = 'https://mini-apps.invescore.mn/api/v1';

Axios.interceptors.request.use((config) => {
  var token = globals.$auth.getToken()
  var removeToken = !!config[0]

  if (token && !removeToken) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

Axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (!error.response || error.response.status >= 500) {
    console.log('Алдаа.')
  }
  return Promise.reject(error)
})
